exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-alert-goto-action.ba-common-button.is-variant_solid{background-color:#000;font-weight:400;padding:0 16px;min-width:fit-content}.ba-alert-goto-action.ba-common-button.is-variant_solid .ba-common-button__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:106px;max-width:126px}.ba-alert-goto-action.ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-goto-action span.ba-common-button__icon.is-right{padding-left:16px}", ""]);

// exports
exports.locals = {
	"alertGoToActionClassName": "\"ba-alert-goto-action\""
};